"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HoverShape = void 0;

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSimpleMaps = require("react-simple-maps");

var _useMapHovered3 = _interopRequireDefault(require("../hooks/useMapHovered"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = {
  root: {
    pointerEvents: "none"
  },
  shape: {}
};

var HoverShape = function HoverShape(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      geo = _ref.geo,
      props = _objectWithoutProperties(_ref, ["classes", "className", "geo"]);

  var _useMapHovered = (0, _useMapHovered3["default"])(),
      _useMapHovered2 = _slicedToArray(_useMapHovered, 1),
      hovered = _useMapHovered2[0];

  return /*#__PURE__*/_react["default"].createElement("g", _extends({
    className: (0, _clsx["default"])("svg-map__hover", classes.root, className)
  }, props), hovered && /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.Geography, {
    className: (0, _clsx["default"])("svg-map__geography", classes.shape),
    geography: hovered
  }));
};

exports.HoverShape = HoverShape;
HoverShape.propTypes = {
  /** Object of class names for the map */
  classes: _propTypes["default"].object,

  /** Root class name for the map */
  className: _propTypes["default"].string,

  /** Determines whether state level labels are shown */
  showLabels: _propTypes["default"].bool,

  /** handler function for hover events */
  onHover: _propTypes["default"].func,

  /** handler for selecting a location */
  onSelect: _propTypes["default"].func
};
/** add the display name */

var exportComponent = (0, _styles.withStyles)(styles, {
  name: "HypSvgMapHoverShape"
})(HoverShape);
exportComponent.displayName = "HoverShape";
var _default = exportComponent;
exports["default"] = _default;